import { axiosInstance } from "utils";

interface NextActivationPayload {
  clientId: string;
  oneTimeApiKey: string;
  nextDatabaseNumber: string;
}

export const activateNextConnection = (payload: NextActivationPayload) =>
  axiosInstance.post("/connection/next/activate", payload); 